import React from 'react';
import './chatbot.scss';

interface ChatMessageProps {
  message: string;
  sender: 'user' | 'bot';
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, sender }) => {
  return (
    <div className={`chat-message ${sender}`}>
      <div className="message-bubble">
        {sender === 'bot' && (
          <div className="bot-avatar">
            <span style={{ 
              fontFamily: 'Poppins', 
              fontWeight: '600',
              fontSize: '16px'
            }}>V</span>
          </div>
        )}
        <div className="message-content">
          {message}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;